import { loginRequest } from 'authConfig'
import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import { msalInstance } from 'index'
import AccountService from 'services/account'
import ReportService from 'services/report'
import RoleService from 'services/roles'
import User from 'services/user'

const HTTP_STATUS_UNAUTHORIZED = 401
const HTTP_STATUS_FORBIDDEN = 403

const addRequestInterceptor = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.request.use(
    async (request: InternalAxiosRequestConfig) => {
      const activeAccount = msalInstance.getActiveAccount()
      if (!activeAccount) {
        console.error('No active account found.')
        msalInstance.loginRedirect(loginRequest)
        return Promise.reject(new Error('No active account found'))
      }

      try {
        const response = await msalInstance.acquireTokenSilent(loginRequest)
        if (request.headers) {
          request.headers.Authorization = `Bearer ${response.accessToken}`
        }
      } catch (error) {
        console.error('Failed to acquire token:', error)
        msalInstance.loginRedirect(loginRequest)
        return Promise.reject(error)
      }

      const subKey = process.env.REACT_APP_SUBSCRIPTION_KEY
      if (subKey && request.headers) {
        request.headers['Ocp-Apim-Subscription-Key'] = subKey
      }

      return request
    },
    error => {
      console.error('Request interceptor error:', error)
      return Promise.reject(error)
    }
  )
}

// Helper function to add response interceptors
const addResponseInterceptor = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    error => {
      if (error.response) {
        const { status } = error.response
        if (
          status === HTTP_STATUS_UNAUTHORIZED ||
          status === HTTP_STATUS_FORBIDDEN
        ) {
          console.error(`Request failed with status ${status}.`)
          // logout()
        }
      } else {
        console.error('Unexpected error:', error)
      }
      return Promise.reject(error)
    }
  )
}

// Create and configure Axios instances
const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({ baseURL })
  addRequestInterceptor(instance)
  addResponseInterceptor(instance)
  return instance
}

const axiosFuncAppInstance = createAxiosInstance(
  process.env.REACT_APP_FUNC_API_BASE_URL || ''
)
const axiosDataverseAppInstance = createAxiosInstance(
  process.env.REACT_APP_DATAVERSE_API_BASE_URL || ''
)
const axiosPortalAppInstance = createAxiosInstance(
  process.env.REACT_APP_FUNC_PORTAL_API_BASE_URL || ''
)

export {
  axiosDataverseAppInstance,
  axiosFuncAppInstance,
  axiosPortalAppInstance,
}

// Export services
export default {
  User: new User(),
  Role: new RoleService(),
  Account: new AccountService(),
  Report: new ReportService(),
}
